import { h, Fragment } from 'preact'
import { useState, useEffect, useMemo, useRef } from 'preact/hooks'
import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import { useMyPublicProfileDid } from 'resources/auth'
import PNFO from 'jlinc-shared/PNFO'
import {
  useAcceptedMembershipsForOrganization,
  usePublicProfiles,
} from 'lib/membershipAppStateHooks'
// import { useSet } from 'lib/useSetHook'
import { useCreateChatChannel } from 'lib/chatHooks'
import { useSearchAll } from 'lib/searchHooks'
import classNames from 'lib/classNames'
import Header from 'components/Header'
import ErrorMessage from 'components/ErrorMessage'
import Button from 'components/Button'
import ButtonRow from 'components/ButtonRow'
import IconButton from 'components/IconButton'
import PeopleList from 'components/PeopleList'
import SearchInput from 'components/SearchInput'
import './index.sass'
import ChipList from 'components/Chiplist'
import TextInput from 'components/TextInput'
import RadioInputGroup from 'components/RadioInputGroup'
import { useChatSynopsis } from 'lib/chatHooks'
import InviteNonMembersModal from './InviteNonMembersModal'
import useAssetUpload from 'lib/useAssetUploadHook'
import { useMembershipsForOrganization } from "lib/membershipAppStateHooks"
import { useOrganizationMembershipInvites, useGetSharedHubMembers } from 'lib/membershipAppStateHooks'
import Alert from 'components/Alert'
import Modal from 'components/Modal'
import TextArea from 'components/TextArea'


const fallbackColors = ['#177bdf', '#1724DF', '#1aae0e', '#DF7B17', '#DFD217', '#A20EAE', '#520EAE ', '#AE0E1A']

export default function NewChatModal({
  className,
  organizationApikey,
  ...props
}) {
  return (
    <Modal className={`chatmodalWindow ${className}`} onClose={props.onClose}>
      <NewChatForm {...{ ...props, organizationApikey }} />
    </Modal>
  )
}

NewChatModal.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  organizationApikey: PropTypes.string.isRequired
}

function NewChatForm({ organizationApikey, onClose, organizations }) {
  const myPublicProfileDid = useMyPublicProfileDid()
  const [viewType, setViewType] = useState('view1')
  const [chatImage, setChatImage] = useState(null)
  const [chatType, setChatType] = useState(1)
  const [chatName, setChatName] = useState('')
  const [filter, setFilter] = useState('')
  const { searchResults } = useSearchAll(filter, 1, 'NewChatModal')
  const { chatSynopsis: synopsis } = useChatSynopsis('NewChatModal')
  const [selectedOrgApikey, setSelectedOrgApikey] = useState('')
  const { uploadAsset, assetUrl, cancelAssetUpload } = useAssetUpload("EditChatInfoModal")
  const [isChatNameValid, setIsChatNameValid] = useState(true)
  const { memberships } = useMembershipsForOrganization(selectedOrgApikey, 'NewChatModal')
  const [showInviteModal, setShowInviteModal] = useState(false)
  const [missingRecipients, setMissingRecipients] = useState([])
  const [existingRecipients, setExistingRecipients] = useState([])
  const { organizationMembershipInvites } = useOrganizationMembershipInvites("AddChatMembersModal")
  const [alert, setAlert] = useState(null)
  const [assetUrlState, setAssetUrlState] = useState('')
  const { getSharedHubMembers, sharedHubMembersData } = useGetSharedHubMembers('NewChatModal')

  const {
    acceptedOrganizationMemberships,
  } = useAcceptedMembershipsForOrganization(organizationApikey, 'NewChatModal')
  const publicProfileDids = new Set()
  acceptedOrganizationMemberships.forEach(m => {
    if (m.memberUserDid && m.memberUserDid !== myPublicProfileDid)
      publicProfileDids.add(m.memberUserDid)
  })

  const { publicProfiles } = usePublicProfiles(
    [...publicProfileDids],
    'NewChatModal'
  )
  const createChatChannel = useCreateChatChannel('NewChatForm')
  const [recipients, setRecipients] = useState(new Set())
  // const [_disabledOrgApikeys, setDisabledOrgApikeys] = useState(new Set())
  const addRecipient = (did) => {
    setRecipients((prevRecipients) => new Set(prevRecipients).add(did))
  }

  const isPrivileged = memberships.some(m => m.memberUserDid === myPublicProfileDid && m.admin)
  useEffect(() => {
    if (organizationApikey) {
      setViewType('view2')
    }
  }, [])

  useEffect(() => {
    getSharedHubMembers()
  }, [getSharedHubMembers])


  const removeRecipient = (did) => {
    setRecipients((prevRecipients) => {
      const newRecipients = new Set(prevRecipients)
      newRecipients.delete(did)
      return newRecipients
    })
  }
  const handleDeleteRecipient = (did) => {
    removeRecipient(did)
  }
  // const profileDids = useMemo(() => [myPublicProfileDid,
  //   ...Array.from(recipients).filter(did => did !== myPublicProfileDid)], [recipients, myPublicProfileDid])

  // const otherProfileDids = profileDids.slice(1)


  // const { suggestedHubs }
  //   = useSuggestedHubs(profileDids, 'NewChatForm')

  // useEffect(() => {
  //   const newDisabledOrgApikeys = new Set(
  //     suggestedHubs
  //       ?.filter(hub =>
  //         hub.memberCount !== otherProfileDids.length && !hub.isAdmin
  //       )
  //       .map(hub => hub.organizationApikey)
  //   )

  //   setDisabledOrgApikeys(newDisabledOrgApikeys)
  // }, [suggestedHubs, otherProfileDids.length])

  useEffect(() => {
    if (chatType === 0) {
      setSelectedOrgApikey('')
    }
  }, [chatType])

  const fileInputRef = useRef(null)

  const triggerFileInputClick = () => {
    fileInputRef.current.click()
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    if (file) {
      setChatImage(file)
      uploadAsset(file)
    }
  }

  // Monitor the hook's assetUrl in an effect
  useEffect(() => {
    if (assetUrl) {
      setAssetUrlState(assetUrl)
    }
  }, [assetUrl])

  const handleRemoveImage = (e) => {
    e.stopPropagation()
    setChatImage(null)
    setAssetUrlState('')
    cancelAssetUpload()

    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }
  const countDids = {}

  if (synopsis) {
    synopsis.forEach(chat => {
      (chat.memberUserDids || []).forEach(did => {
        if (did !== myPublicProfileDid) {
          countDids[did] = (countDids[did] || 0) + 1
        }
      })
    })
  }

  const sortedDids = Object.entries(countDids).sort((a, b) => b[1] - a[1]).slice(0, 3).map(entry => entry[0])
  const suggestedDids = useMemo(() => {
    if (!organizationApikey && sharedHubMembersData?.shared) {
      return sharedHubMembersData.shared.slice(0, 5)
    }
    return sortedDids
  }, [organizationApikey, sharedHubMembersData, sortedDids])

  const handleNextOrCreate = () => {
    if (viewType === 'view2' && organizationApikey) {
      setViewType('view1')
    } else {
      create()
    }
  }
  const { publicProfiles: suggestedProfiles } = usePublicProfiles([...suggestedDids], 'NewChatModalSuggested')

  const { publicProfiles: selectedprofiles } = usePublicProfiles(
    [...recipients],
    'NewChatModal'
  )

  // Filter search results to only include shared hub members if no organization is specified
  const filteredSearchResults = useMemo(() => {
    if (!organizationApikey && sharedHubMembersData?.shared && searchResults?.publicProfiles) {
      const sharedHubMemberDidsSet = new Set(sharedHubMembersData?.shared)

      return searchResults.publicProfiles.filter(profile =>
        sharedHubMemberDidsSet.has(profile.did)
      )
    }

    return searchResults?.publicProfiles || []
  }, [organizationApikey, sharedHubMembersData?.shared, searchResults])

  const people = (organizationApikey ? publicProfiles : filteredSearchResults || []).map(publicProfile => {
    const selected = recipients.has(publicProfile.did)
    return {
      ...publicProfile,
      className: classNames('NewChatModal-recipient', { selected }),
      href: null,
      onClick: () => selected ? removeRecipient(publicProfile.did) : addRecipient(publicProfile.did),
      buttons: selected ? (
        <IconButton
          type="selected"
          white={selected}
          onClick={() => selected ? removeRecipient(publicProfile.did) : addRecipient(publicProfile.did)}
        />
      ) : null
    }
  })

  const selectedPublicProfiles = selectedprofiles
    .filter(pp => recipients.has(pp.did))


  const isOrganizationSelected = false

  const [createError, setCreateError] = useState()

  const findMissingRecipients = (selectedDids, data) => {
    const dataDids = new Set(data.map(item => item.memberUserDid))
    return Array.from(selectedDids).filter(did => !dataDids.has(did))
  }
  const selectedColor = fallbackColors[Math.floor(Math.random() * fallbackColors.length)]
  const chatImageValue = assetUrlState || selectedColor


  const dmUsername = selectedPublicProfiles[0]?.username || selectedPublicProfiles[0]?.displayName

  const create = () => {

    const apiKeyToUse = selectedOrgApikey || organizationApikey

    if (selectedOrgApikey && isPrivileged) {
      const missingRecipients = findMissingRecipients(recipients, memberships)
      const existingRecipients = [...recipients].filter(
        (did) => !missingRecipients.includes(did)
      )

      if (missingRecipients.length > 0) {
        setShowInviteModal(true)
        setMissingRecipients(missingRecipients)
        setExistingRecipients(existingRecipients)
        return
      }
    }

    function finalizeChatName(name) {
      if (selectedPublicProfiles?.length === 1 && chatName === dmUsername)
        return 'unnamed chat'
      return name
    }

    // Determine the correct chat type based on the presence of an organization API key
    let chatTypeToUse = 'direct_chat'

    if (apiKeyToUse) {
      chatTypeToUse = chatType === 0 ? 'public_hub_chat' : 'private_hub_chat'
    }


    createChatChannel({
      type: chatTypeToUse,
      organizationApikey: apiKeyToUse,
      memberUserDids: [...recipients],
      name: finalizeChatName(chatName) || undefined,
      chatImage: chatImageValue
    }).then(onClose, setCreateError)
  }

  const handleInviteNonMembers = () => {
    organizationMembershipInvites({
      organizationApikey: selectedOrgApikey || organizationApikey,
      memberUserDids: [...missingRecipients],
    })
      .then(() => {
        if (existingRecipients.length === 0) {
          setAlert({
            type: 'info',
            title: 'Invitations Sent',
            message: 'Invitations have been sent. Recipients must accept the invitation to join the chat.',
          })
          setTimeout(() => {
            onClose()
          }, 1000)
          return
        }
        createChatChannel({
          type: (selectedOrgApikey || organizationApikey) ? 'private_hub_chat' : 'direct_chat',
          organizationApikey: selectedOrgApikey || organizationApikey,
          memberUserDids: [...existingRecipients],
          name: chatName || undefined,
          chatImage: chatImageValue,
        }).then(onClose, setCreateError)
      })
      .catch((error) => {
        console.error('Failed to invite non-members:', error)
        setCreateError('Failed to invite non-members')
      })
      .finally(() => {
        setShowInviteModal(false)
      })
  }

  const empty = recipients.size === 0

  const handleSearchInput = (query) => {
    setFilter(query)
  }
  let organizationOptions = []

  if (organizations) {
    Array.from(organizations).map(organization => {
      organizationOptions.push({
        label: organization.name,
        value: organization.apikey,
      })
    })
  }
  const [selectedOrganization, setSelectedOrganization] = useState('')
  const renderContentBasedOnViewType = () => {
    if (viewType === 'view1') {
      return (
        <>
          <div className="newChat-header-main">
            {organizationApikey ? (
              <span>Start a New {PNFO.singular} Chat</span>
            ) : sharedHubMembersData?.shared?.length ? (
              <span>Start a New Direct Chat</span>
            ) : (
              <span>Join a {PNFO.singular} </span>
            )}
            <IconButton onClick={onClose} type="cancel" />
          </div>
          <Header size="lg" style={{
            fontWeight: 600, color: "#747881", fontSize: '16px', padding: '0.5rem 1rem',
            ...((!sharedHubMembersData?.shared || sharedHubMembersData.shared.length === 0)
            && !organizationApikey ? { display: 'none' } : {})

          }}> Select Members</Header>
          <div className="newchat-header-input" style={{
            ...((!sharedHubMembersData?.shared || sharedHubMembersData.shared.length === 0)
            && !organizationApikey ? { display: 'none' } : {})
          }}>
            <Header size="md" style={{ ...((!sharedHubMembersData?.shared || sharedHubMembersData.shared.length === 0)
              && !organizationApikey ? { display: 'none' } : {}) }}>
              <SearchInput
                placeholder="Search for a person"
                onInput={handleSearchInput}
                value={filter}
                onKeyDown={e => e.stopPropagation()}
                onClear={() => setFilter('')}
              />
            </Header>
            {Array.from(selectedPublicProfiles).length > 0 && <Header size="md"
              style={!empty ? { borderBottom: '1.09px solid #DBDDE1', padding: '1rem 10px',
                maxHeight: '100px', overflow: 'auto', borderRadius: '8px' } : {}}>
              {!empty &&
                <ChipList people={Array.from(selectedPublicProfiles)} onDelete={handleDeleteRecipient} truncateTo={6} />
              }
            </Header>}
          </div>
          <div className="chatlists" >
            <Header size="lg"
              style={{
                padding: '0.5rem 0', color: "#747881", fontSize: '16px',
                fontWeight: 600, ...((!sharedHubMembersData?.shared || sharedHubMembersData.shared.length === 0)
                  && !organizationApikey ? { display: 'none' } : {})
              }}>
              {filter && filter.length > 0
                ? `${filter.toLowerCase() ? people.filter(person =>
                  person.username?.toLowerCase().includes(filter.toLowerCase())
                ).length : people.length} Result${people.filter(person =>
                  person.username?.toLowerCase().includes(filter.toLowerCase())
                ).length !== 1 ? 's' : ''}`
                : "Suggestions"}
            </Header>

            <PeopleList
              className="peopleList-newChat"
              style={{
                ...((!sharedHubMembersData?.shared || sharedHubMembersData.shared.length === 0)
                  && !organizationApikey ? { height: 'auto' } : {})
              }}
              people={filter && filter.length > 0 ?
                (organizationApikey ?
                  people.filter(person => person.username?.toLowerCase().includes(filter.toLowerCase()))
                  :
                  people
                )
                :
                (organizationApikey ?
                  publicProfiles.map(profile => {
                    const selected = recipients.has(profile.did)
                    return {
                      ...profile,
                      className: classNames('NewChatModal-recipient', { selected }),
                      href: null,
                      onClick: () => selected ? removeRecipient(profile.did) : addRecipient(profile.did),
                      buttons: selected ? (
                        <IconButton
                          type="selected"
                          white={selected}
                          onClick={() => selected ? removeRecipient(profile.did) : addRecipient(profile.did)}
                        />
                      ) : <IconButton type="create" onClick={() => addRecipient(profile.did)} />
                    }
                  }) :
                  suggestedProfiles.map(profile => {
                    const selected = recipients.has(profile.did)
                    return {
                      ...profile,
                      className: classNames('NewChatModal-recipient', { selected }),
                      href: null,
                      onClick: () => selected ? removeRecipient(profile.did) : addRecipient(profile.did),
                      buttons: selected ? (
                        <IconButton
                          type="selected"
                          white={selected}
                          onClick={() => selected ? removeRecipient(profile.did) : addRecipient(profile.did)}
                        />
                      ) : <IconButton type="create" onClick={() => addRecipient(profile.did)} />
                    }
                  })
                )
              }
              filter={filter?.toLowerCase() || undefined}
              onEmpty={
                !empty && filter && filter.length > 0 ? (
                  <Header size="sm" italic style={{ padding: '1rem', textAlign: 'center' }}>
                    No one matches your search
                  </Header>
                ) : (
                  !organizationApikey &&
                    (!sharedHubMembersData?.shared || sharedHubMembersData?.shared?.length === 0) ? (
                      <Header size="sm" italic style={{ padding: '1rem', textAlign: 'center' }}>
                      You need to be part of at least one hub in order to direct chat someone
                      </Header>
                    ) : ''
                )
              }
            />
          </div >

        </>
      )
    } else {
      // Placeholder for view2 content
      return (
        <>
          <div className="newChat-header-main">
            <span>Start a New Hub Chat</span>  <IconButton onClick={onClose} type="cancel" />
          </div>
          <div className="NewChatModal-form" style={{ padding: '1rem' }} >
            <div>
              <p style={{ fontWeight: 'bold' }}>Chat Name
                <sup style={{ color: 'red', fontSize: '1rem', top: 0, left: 0 }}>*</sup></p>
              <TextInput
                style={{
                  width: '90%',
                  margin: 0,
                  borderColor: isChatNameValid ? 'initial' : 'red',
                }}
                position="right"
                placeholder={chatName}
                value={chatName === 'Chat Name*' ? '' : chatName}
                onChange={value => {
                  setChatName(value)
                  if (!isChatNameValid) {
                    // Re-validate as user types
                    setIsChatNameValid(true)
                  }
                }}
              />
            </div>

            <div>
              <p style={{ fontWeight: 'bold' }}>Chat Image</p>
              <div className="newChat-avatar" style={{ cursor: 'pointer' }} >
                <input type="file" onChange={handleFileChange} ref={fileInputRef} hidden />
                <div onClick={triggerFileInputClick}
                  style={{
                    width: '100%', height: '100%', display: 'flex', alignItems: 'center',
                    justifyContent: 'center'
                  }}>

                  {assetUrlState || chatImage ?
                    <div className="avatarImg1">
                      <img src={assetUrlState} alt="Uploaded Asset"
                        style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '10px' }} />
                      <IconButton
                        type="cancel-circled"
                        onClick={handleRemoveImage}
                        className="avatarImg-closeButton"
                      />
                    </div>
                    : <div className="avatarImg1" style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'
                    }}>
                      <Icon type="uploadIcon1" />
                      <span style={{ fontSize: '10px' }}>Upload</span>
                    </div>}
                </div>

              </div>
            </div>

            <div>
              <p style={{ fontWeight: 'bold' }}>Chat Description</p>
              <TextArea placeholder="Add Description" />
            </div>
            <div>
              <p style={{ fontWeight: 'bold' }}>Select type of Chat
                <sup style={{ color: 'red', fontSize: '0.8rem', top: 0, left: 0 }}>*</sup></p>
              <RadioInputGroup
                value={chatType}
                onChange={setChatType}
                options={[
                  {
                    label: <span>Public - Everyone in the Hub will be part of it</span>,
                  },
                  {
                    label: <span>Private - Can only be joined by invitation </span>,
                  }
                ]}
                placeholder="choose Chat Type"
              />
            </div>
          </div>
        </>
      )
    }
  }
  const isButtonDisabled = useMemo(() => {
    return !chatName
  }, [chatType, chatName, selectedOrgApikey])


  return <> <div className="NewChatModal-form">
    <ErrorMessage error={createError} onDismiss={() => { setCreateError() }} />
    {isOrganizationSelected && <Header size="md">
      <select
        className={'NewChatModal-form-select'}
        value={selectedOrganization}
        onChange={e => setSelectedOrganization(e.target.value)}
        placeholder="Select a hub"
      >
        {organizationOptions.map(option => (
          <option className={'NewChatModal-form-option'} key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </Header>}
    {renderContentBasedOnViewType()}
  </div>
  <ButtonRow className="ButtonRow_newChat" >
    <Button
      type="normal"
      value="Back"
      onClick={onClose}
    />

    {viewType === "view1" ?
      <Button
        type="primary"
        value={"Start Chat"}
        disabled={empty}
        className={empty ? 'button-disabled' : ''}
        onClick={chatType === 1 ? create : handleNextOrCreate}
      /> :
      <Button
        type="primary"
        value="Next"
        disabled={isButtonDisabled}
        className={isButtonDisabled ? 'button-disabled' : ''}
        onClick={handleNextOrCreate}
      />
    }

  </ButtonRow>
  {showInviteModal && (
    <InviteNonMembersModal
      missingRecipients={missingRecipients}
      onConfirm={handleInviteNonMembers}
      onCancel={() => setShowInviteModal(false)}
    />
  )}

  {alert && (
    <Alert
      type={alert.type}
      title={alert.title}
      onDismiss={() => setAlert(null)}
      position="right-bottom"
    >
      {alert.message}
    </Alert>
  )}

  </>
}
